import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowUpRightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M3.75,15c-.192,0-.384-.073-.53-.22-.293-.293-.293-.768,0-1.061L13.47,3.47c.293-.293,.768-.293,1.061,0s.293,.768,0,1.061L4.28,14.78c-.146,.146-.338,.22-.53,.22Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M14.25,10.51c-.414,0-.75-.336-.75-.75V4.5h-5.26c-.414,0-.75-.336-.75-.75s.336-.75,.75-.75h6.01c.414,0,.75,.336,.75,.75v6.01c0,.414-.336,.75-.75,.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconArrowUpRightFill18.js.map